// SPDX-License-Identifier: AGPL-3.0-or-later
// SPDX-FileCopyrightText: 2026 Ben Richardson <hi@ben.gy>
import type { ViewContext } from '../viewContext';
import { buildInsights } from '../analysis';
import { escapeHtml } from '../utils/format';

export function renderInsights(root: HTMLElement, ctx: ViewContext): void {
  const insights = buildInsights(ctx.data.postcodes, ctx.data.national, ctx.data.meta);

  root.innerHTML = `
    <div class="view-head">
      <h1 class="view-title">What the numbers say</h1>
      <p class="view-sub">Findings pulled automatically from the ${ctx.data.meta.snapshotDate} snapshot. Click a postcode
        chip to open it.</p>
    </div>
    <div class="insight-grid">
      ${insights
        .map(
          (ins) => `
        <div class="insight ${ins.severity}">
          <h3>${escapeHtml(ins.title)}</h3>
          <p>${escapeHtml(ins.body)}</p>
          ${
            ins.postcodes.length
              ? `<div class="insight-links">${ins.postcodes.map((pc) => `<button class="chip" data-pc="${pc}">${escapeHtml(pc)}</button>`).join('')}</div>`
              : ''
          }
        </div>`,
        )
        .join('')}
    </div>
  `;

  root.addEventListener('click', (e) => {
    const chip = (e.target as Element).closest('[data-pc]');
    if (chip) ctx.openPostcode(chip.getAttribute('data-pc') as string);
  });
}
